import { render } from "./NewPass.vue?vue&type=template&id=27551de5"
import script from "./NewPass.vue?vue&type=script&lang=js"
export * from "./NewPass.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__